export default "__VITE_ASSET__B8fTF8hO__"